import React from 'react';
/* eslint-disable @typescript-eslint/no-empty-function */

export const Context = React.createContext({
  omniUrlArgs: '',
  trackTemplateEvent: (
    eventWithValToTrack: string,
    fromCity?: string,
    toCity?: string
  ): void => {},
  selectedDay: null as Date | null,
  setSelectedDay: (arg: Date) => {}
});

type Props = {
  omniUrlArgs: string;
  trackTemplateEvent: (
    eventWithValToTrack: string,
    fromCity?: string,
    toCity?: string
  ) => void;
  children?: React.ReactNode;
};

type State = {
  selectedDay: Date | null;
};

class AppContextProvider extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      selectedDay: null
    };
  }

  componentDidMount() {
    const d = new Date();
    d.setDate(d.getDate() + 1);
    this.setState({ selectedDay: d });
  }

  setSelectedDay = (data: Date): void => {
    this.setState({ selectedDay: data });
  };

  render() {
    const { omniUrlArgs, trackTemplateEvent, children } = this.props;
    const { selectedDay } = this.state;

    return (
      <Context.Provider
        value={{
          omniUrlArgs,
          trackTemplateEvent,
          selectedDay,
          setSelectedDay: this.setSelectedDay
        }}
      >
        {children}
      </Context.Provider>
    );
  }
}

export const AppContextConsumer = Context.Consumer;
export default AppContextProvider;
